// Helpers to normalize numeric-looking values and build numeric counterparts
export const toNumberOrNull = (value) => {
  if (value === undefined || value === null) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "string") {
    const cleaned = value.replace(/,/g, "").trim();
    if (!cleaned) return null;
    const parsed = parseFloat(cleaned);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export const buildNumericAmountFields = (project = {}) => {
  const numericFields = {};
  const addField = (sourceKey, targetKey) => {
    numericFields[targetKey] = toNumberOrNull(project[sourceKey]);
  };

  addField("amountIncVat", "amountIncVat_num");
  addField("cost", "cost_num");
  addField("income", "income_num");
  addField("vat", "vat_num");

  return numericFields;
};
